// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 371) return "371.10c2a39a6aaa9cde9897.web-centralized-notifications.js";
	if (chunkId === 989) return "989.9d36a6be278637e445eb.web-centralized-notifications.js";
	// return url for filenames based on template
	return undefined;
};